import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { DailyResponseChart, CumulativeResponseChart } from './charts/ResponseCharts';

const OverviewTab = ({ stats, invitationStats, survey }) => {
    return (
        <>
            {/* Overview Statistics */}
            <Row className="mb-4">
                <Col md={4}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>Total Responses</Card.Title>
                            <h3>{stats.totalResponses}</h3>
                            <div className="mt-2">
                                <small className="text-success">
                                    Completed: {stats.submittedResponses}
                                </small><br/>
                                <small className="text-warning">
                                    Incomplete: {stats.incompleteResponses}
                                </small>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>Completion Rate</Card.Title>
                            <h3>{stats.completionRate}%</h3>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>Invitations</Card.Title>
                            <h3>{invitationStats.totalInvitations}</h3>
                            <div className="mt-2">
                                <small className="text-success">
                                    Completed: {invitationStats.completedCount} ({(invitationStats.completionRate).toFixed(1)}%)
                                </small><br/>
                                <small className="text-info">
                                    Started: {invitationStats.startedCount} ({(invitationStats.startRate).toFixed(1)}%)
                                </small>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className="mb-4">
                <Col md={4}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>Average Questions</Card.Title>
                            <h3>{stats.averageQuestionsAnswered}</h3>
                            <small className="text-muted">of {survey?.questions?.length} total</small>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>Average Follow-ups</Card.Title>
                            <h3>{stats.averageFollowupsPerQuestion}</h3>
                            <small className="text-muted">per question</small>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>Conversion</Card.Title>
                            <h3>
                                {invitationStats.totalInvitations > 0
                                    ? ((stats.totalResponses / invitationStats.totalInvitations) * 100).toFixed(1)
                                    : 0}%
                            </h3>
                            <small className="text-muted">responses from invitations and organic</small>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Response Rate Charts */}
            <Row className="mb-4">
                <Col md={6}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Daily Response Rate</Card.Title>
                            <DailyResponseChart responsesByDate={stats.responsesByDate} />
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Cumulative Responses</Card.Title>
                            <CumulativeResponseChart responsesByDate={stats.responsesByDate} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default OverviewTab;